import {ProductContent} from './productContent';
import {ProductBrand} from './productBrand';
import {ProductCategory} from './productCategory';

export class EvendProduct {
  _id?: string;
  image: string;
  name: string;
  status: number;
  price: number;
  isHot: boolean;
  content: Array<ProductContent>;
  brand: ProductBrand;
  categories: Array<ProductCategory>;
  tags: Array<any>;
  updatedAt: string;
  createdAt: string;
  evendProductType: EvendProductType;
  constructor() {
    this.status = 0;
  }
}
export class EvendProductType {
  _id?: string;
  name: string;
  status: number;
  categoryCount: number;
  productCount: number;
  constructor(status?: number) {
    this.status = status;
  }
}

export class EvendProductSearchFilter {
  brand: string;
  category: string;
  name: string;
}
export class EvendProductSearchFilterSuperAdmin {
  evendProductType: string;
  brandId: string;
  categoryId: string;
  name: string;
  status?: number;
}
export class EvendProductTag {
  _id?: string;
  name: string;
}


// WEBPACK FOOTER //
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/models/evendProduct.ts